"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBarProfile = void 0;
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const svgs_1 = require("../assets/svgs");
function NavBarProfile(props) {
    const theme = (0, material_1.useTheme)();
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const isOpen = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "h-[2.5rem] cursor-pointer flex flex-row gap-[1rem] items-center", onClick: handleClick },
            react_1.default.createElement(material_1.Avatar, { alt: props.name, src: props.iconUrl, children: getInitials(props.name), sx: {
                    width: '2.5rem',
                    height: '2.5rem',
                } }),
            react_1.default.createElement("div", { className: "hidden md:!flex flex-row gap-[0.5rem] items-center" },
                react_1.default.createElement(material_1.Typography, { sx: {
                        fontFamily: 'Effra',
                        color: theme.palette.primary.contrastText,
                        fontSize: '1rem',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: '1.5rem',
                        letterSpacing: '0.00938rem',
                        fontFeatureSettings: "'liga' off, 'clig' off",
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '150px',
                    } }, props.name.length === 0 ? 'N/A' : props.name),
                isOpen ? react_1.default.createElement(svgs_1.UpArrowFilled, null) : react_1.default.createElement(svgs_1.DownArrowFilled, null))),
        react_1.default.createElement(material_1.Menu, { anchorEl: anchorEl, id: "account-menu", open: isOpen, onClose: handleClose, onClick: handleClose, PaperProps: {
                elevation: 0,
                sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                    },
                    '&::before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                    },
                },
            }, transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' } }, react_1.default.Children.toArray(props.children)
            .filter(react_1.isValidElement)
            .map((child, index) => {
            return (react_1.default.createElement("div", { key: index, onClick: handleClose }, child));
        }))));
}
exports.NavBarProfile = NavBarProfile;
function getInitials(name) {
    if (name.length === 0) {
        return '';
    }
    const initialCharacters = [];
    const arr = name.split(' ');
    for (const str of arr) {
        if (str.length > 0) {
            initialCharacters.push(str.charAt(0));
        }
    }
    if (arr.length === 0) {
        return '';
    }
    else {
        return initialCharacters.join('');
    }
}
